import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { IonCol, IonRow } from "@ionic/vue";
import { computed } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";
import InputAmount from "@/components/input/InputAmount.vue";
import SelectVariant from "@/components/selects/SelectVariant.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { INFORMATION_TYPE } from "@/types/enum/notification";
import { NewsModalProductInterfaceProps } from "@/types/props/component";
import { NewsModalProductInterfaceEmits } from "@/types/emits/component";
import { ProductMaster } from "@/types/supplier";
import { useLocationStore } from "@/stores/locations";
import { useSupplierStore } from "@/stores/suppliers";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsModalProductInterface',
  props: {
    modelValue: {},
    amount: {},
    information: {},
    cart: { type: Boolean }
  },
  emits: ["update:modelValue", "update:amount", "add"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const supplierStore = useSupplierStore()

const amount = computed<number>({
    get: () => {
        return props.amount
    },
    set: (value) => {
        emit('update:amount', value)
    }
})

const product = computed<ProductMaster>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const hasVariants = computed<boolean>(() => (props.information.kind === INFORMATION_TYPE.PRODUCT_PRESENTATION || props.information.kind === INFORMATION_TYPE.PROMOTION)
    && props.information?.products.length > 0
)

const availableProducts = computed(() => {
    const matchedProducts = []
    for (const product of props.information.products) {
        if (product.availableBy?.length) matchedProducts.push(product)
    }
    if (!matchedProducts.length && props.cart) return props.information.products
    return matchedProducts
})

const adjustStep = (stepAmount: number | undefined, amount: number): number => {
    if (!stepAmount || (amount % stepAmount == 0)) return amount

    const offset = amount % stepAmount
    return amount -= offset
}

const setStartAmount = (product: ProductMaster): void => {
    if (product.recommendedAmount) {
        amount.value = product.recommendedAmount
        return
    }

    if (product.limitOrderSize && amount.value > product.limitOrderSize) {
        const newSize = product.limitOrderSize
        amount.value = adjustStep(product.stepAmount, newSize) //Enforce limitOrderSize multiple of stepSize in controller?
        return
    }

    // amount.value = adjustStep(product.stepAmount, amount.value)
    amount.value = product.stepAmount || 1
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hasVariants.value && availableProducts.value.length)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(SelectVariant, {
                  modelValue: product.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((product).value = $event)),
                  options: availableProducts.value,
                  onChange: setStartAmount
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (availableProducts.value.length)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 1,
          class: "mt-3 max-width"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { size: "12" }, {
              default: _withCtx(() => [
                _createVNode(InputAmount, {
                  modelValue: amount.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((amount).value = $event)),
                  modelModifiers: { number: true },
                  "amount-step": product.value?.stepAmount ?? 1,
                  max: product.value?.limitOrderSize,
                  "min-value": product.value?.stepAmount ?? 1,
                  "direct-input-disabled": Number(product.value?.stepAmount) > 1
                }, null, 8, ["modelValue", "amount-step", "max", "min-value", "direct-input-disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (availableProducts.value.length)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center" }, {
              default: _withCtx(() => [
                _createVNode(ButtonBase, {
                  color: _unref(ION_VARIANT).CORAL,
                  class: "ml-3 mr-3 fw-b wrap-button tt-none max-width",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('add'))),
                  disabled: !amount.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`modal.${__props.cart ? 'addCart' : 'addList'}`)), 1)
                  ]),
                  _: 1
                }, 8, ["color", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})